import { t } from "i18next";
import { useState } from "react";
import Button from "shared/UI/Buttons/Button";
import { Hideable } from "shared/UI/Hideable/Hideable";
import { GeneralActivityInputModal } from "./GeneralActivityInputModal";
import { trackAddHealthData, trackCancelHealthData } from "core/monitoring/Events";
import { TrackerType } from "core/state/Trackers/TrackerType";

export const GeneralActivityInput = () => {
  const [showAddDataModal, setShowAddDataModal] = useState(false);

  const handleAddData = () => {
    trackAddHealthData(TrackerType.Activity);
    setShowAddDataModal(true);
  };

  const handleCloseModal = () => {
    trackCancelHealthData(TrackerType.Activity);
    setShowAddDataModal(false);
  };

  return (
    <>
      <Button text={t("wellbeing.trackers.activity.addData.addButtonLabel")} onClick={handleAddData} />
      <Hideable hidden={!showAddDataModal}>
        <GeneralActivityInputModal onClose={handleCloseModal} />
      </Hideable>
    </>
  );
};
